import { useBreakpointValue } from "native-base";
import { ByIpssrDesktop, ByIpssrMobile } from "./components";

export const OutcomesByIpssr = () => {
  const breakpoint = useBreakpointValue({ xl: "xl" });
  if (breakpoint === "xl") return <ByIpssrDesktop />;
  return <ByIpssrMobile />;
};
